import QRCode from "qrcode";

const ISSUER = "Managed Services Center";

export function buildTotpKeyUri(email, secret) {
  const account = encodeURIComponent(email || "user");
  return `otpauth://totp/${ISSUER}:${account}?secret=${secret}&issuer=${encodeURIComponent(
    ISSUER
  )}`;
}

/** Groups TOTP secret as 4-character chunks for display (e.g. PDF / modal). */
export function formatTotpSecretForDisplay(secret) {
  if (!secret) return "";
  const cleaned = String(secret).replace(/\s+/g, "").toUpperCase();
  return cleaned.replace(/(.{4})/g, "$1 ").trim();
}

export async function totpSecretToDataUrl(email, secret, options = {}) {
  const { width = 220 } = options;
  const uri = buildTotpKeyUri(email, secret);
  return QRCode.toDataURL(uri, { margin: 1, width });
}
